import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface Blog {
  blog_id: string;
  title: string;
  short_description: string;
  description: string;
  image_path: string;
  meta_title: string | null;
  meta_keywords: string | null;
  meta_description: string | null;
  h1_tag: string | null;
  author: string;
  status: string;
  is_active: string;
  created_date: string;
  updated_date: string;
}

@Component({
  selector: 'app-blog-view-dialog',
  templateUrl: './blog-view-dialog.component.html',
  styleUrls: ['./blog-view-dialog.component.scss']
})
export class BlogViewDialogComponent {
  readonly blog = inject<Blog>(MAT_DIALOG_DATA);

  private readonly dialogRef =
    inject(MatDialogRef<BlogViewDialogComponent>);

  get imageUrl(): string | null {
    return this.blog.image_path
      ? `${this.blog.image_path}`
      : null;
  }

  close(): void {
    this.dialogRef.close();
  }

  isPublished(status: string): boolean {
    return status?.toLowerCase() === 'published';
  }

  isActive(value: string): boolean {
    return value === '1';
  }
}